import * as exElement from '../../../utils/element';

// ----------------------------------------------------------------------------

function divider(config: Record<string, any> = {}): HTMLElement {
    // Create element (divider)
    const elDivider = exElement.create({
        merge: config,
        tag: 'hr',
        class: {
            new: 'dropdown-divider',
        },
    });

    // Return
    return elDivider;
}

// ----------------------------------------------------------------------------

export default divider;
